import {Component, input, model, output, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-toggle",
    templateUrl: "./toggle.component.html",
    styleUrls: ["./toggle.component.scss"],
})
export class ToggleComponent {
    readonly $toggle = model(false, {alias: "toggle"})
    readonly $disabled = input(false, {alias: "disabled"})
    readonly toggleChange = output<boolean>()
}
